import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import notifications from './modules/notifications';
import user from './modules/user';
import unit from './modules/unit';
import docs from './modules/docs';
import config from './modules/config';
import ticketCrm from './modules/ticketCrm';
import faqs from './modules/faqs';
import banners from './modules/banners';
import bulletins from './modules/bulletins';
import iframes from './modules/iframes';
import newsVideos from './modules/newsVideo';
import events from './modules/events';
import toExpireSlips from './modules/paymentSlips/toExpire';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    notifications,
    user,
    unit,
    docs,
    config,
    ticketCrm,
    faqs,
    banners,
    bulletins,
    iframes,
    newsVideos,
    events,
    toExpireSlips
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js